import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import "swiper/css";

import Breadcrumb from "../../components/breadcrumb/index";
import movieFetch from "../../redux/movie/movieAction";
import genreFetch from "../../redux/genre/genreAction";
import { Star, ThumbsUp } from "phosphor-react";

const Index = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const movieState = useSelector((state) => state.movieState);

  let actorsA = movieState?.movie?.actors?.split(", ");
  let writersA = movieState?.movie?.writer?.split(", ");

  useEffect(() => {
    dispatch(genreFetch());
    dispatch(movieFetch(params?.id));
  }, [dispatch]);
  return (
    <>
      <div className="p-4 lg:px-24">
        <Breadcrumb curentName={movieState?.movie?.title} />
        {movieState?.loading ? (
          <h1>Loading...</h1>
        ) : movieState?.error ? (
          <h1>Loading...</h1>
        ) : (
          <div>
            <div className="lg:grid lg:grid-cols-12 lg:space-x-6">
              <div className="col-span-12 lg:col-span-2 ">
                <img
                  src={movieState?.movie?.poster}
                  className="lg:w-52 rounded-xl"
                  alt=""
                />
              </div>

              <div className="col-span-12 lg:col-span-10 !space-x-0 space-y-4 lg:w-full">
                <div className="my-4 lg:my-0 lg:flex w-full items-center justify-between">
                  <h1 className="text-xl lg:text-3xl mb-4 lg:mb-0 font-bold">
                    {movieState?.movie?.title}
                  </h1>
                  <div className="flex space-x-2">
                    <div className="flex items-center space-x-2 z-[11] px-4 py-1 bg-green-500 rounded-full">
                      <p>{movieState?.movie?.imdb_votes}</p>
                      <ThumbsUp
                        className="text-slate-900"
                        size={16}
                        weight="fill"
                      />
                    </div>
                    <div className="flex items-center space-x-2 z-[11] px-4 py-1 bg-yellow-400 rounded-full">
                      <p>10/{movieState?.movie?.imdb_rating}</p>
                      <Star
                        className="text-slate-900"
                        size={16}
                        weight="fill"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <h1 className="capitalize text-xl font-medium">genres</h1>
                </div>
                <div className="flex space-x-3 overflow-auto whitespace-nowrap">
                  {movieState?.movie?.genres?.map((genre, index) => (
                    <p
                      key={index}
                      className="px-4 py-1 bg-slate-100 rounded-full"
                    >
                      {genre}
                    </p>
                  ))}
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <h1 className="capitalize text-xl font-medium">actors</h1>
                </div>
                <div className="flex space-x-3 overflow-auto whitespace-nowrap">
                  {actorsA?.map((actor, index) => (
                    <p
                      key={index}
                      className="px-4 py-1 bg-slate-100 rounded-full"
                    >
                      {actor}
                    </p>
                  ))}
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <h1 className="capitalize text-xl font-medium">writer</h1>
                </div>
                <div className="flex space-x-3 overflow-auto whitespace-nowrap">
                  {writersA?.map((writer, index) => (
                    <p
                      key={index}
                      className="px-4 py-1 bg-slate-100 rounded-full"
                    >
                      {writer}
                    </p>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-slate-200 w-full h-[1px] my-4"></div>
            <div className="space-y-4">
              <div className="flex items-center space-x-4">
                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                <h1 className="capitalize text-xl font-medium">
                  About the {movieState?.movie?.title}
                </h1>
              </div>
              <p className="flex space-x-3">{movieState?.movie?.plot}</p>
            </div>
            {movieState?.movie?.images && (
              <Swiper
                className="!py-8"
                spaceBetween={24}
                slidesPerView={1}
                breakpoints={{
                  // when window width is >= 320px
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  // when window width is >= 480px
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                  },
                  // when window width is >= 640px
                  640: {
                    slidesPerView: 1,
                    spaceBetween: 21,
                  },
                  // when window width is >= 768px
                  768: {
                    slidesPerView: 1,
                    spaceBetween: 21,
                  },
                  // when window width is >= 1024px
                  1024: {
                    slidesPerView: 1,
                    spaceBetween: 21,
                  },
                  // when window width is >= 1440px
                  1440: {
                    slidesPerView: 3,
                    spaceBetween: 21,
                  },
                }}
              >
                {movieState?.movie?.images?.map((imgs, index) => (
                  <SwiperSlide key={index}>
                    <img src={imgs} className="rounded-xl" alt="" />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Index;
